"use client";
import { alchemy } from "@account-kit/infra";
import { Chain, custom, EIP1193Provider, Hex, Transport, Account as ViemAccount, createWalletClient } from "@sdk/viem";
import type { Connector } from "@wagmi/core";
import { AlchemySigner } from "@account-kit/core";
import { poll } from "@sdk/utils";
import { useHostStore } from "../stores/useHostStore";
import chains from "../config/chains";
import { alchemyChains } from "../config/alchemy";
export type AccountLinkingStatus = "initial" | "linking" | "success" | "error";

// Create ViewType from wallet IDs
export type ViewType = "social" | "all" | "account_linking" | "whitelist_check" | string;
export async function authenticateWithSdk({
  address,
  accountType,
  signer,
  jwt,
  provider,
  connector,
}: {
  address: Hex;
  accountType: "eoa" | "sca";
  signer: AlchemySigner;
  jwt: string;
  connector?: Connector;
  provider?: EIP1193Provider;
}) {
  const _provider = provider || (await connector?.getProvider());
  if (!_provider && accountType === "eoa") throw new Error("No provider found");
  let account: ViemAccount | Hex;
  let transport: Transport;
  let chain = useHostStore.getState().activeChain;
  if (accountType === "sca") {
    const alchSigner = signer as AlchemySigner;
    const authDetails = await poll(() => alchSigner.getAuthDetails(), 1000, 10);
    if (!authDetails) throw new Error("Failed to get auth details");
    account = alchSigner.toViemAccount() as ViemAccount;
    transport = alchemy({ apiKey: process.env.ALCHEMY_API_KEY as string }) as Transport;
    chain = chain || alchemyChains[0];
  } else {
    account = address;
    transport = custom(_provider as EIP1193Provider);
    chain = chain || chains[0];
  }

  const wallet = createWalletClient({
    account,
    transport,
    chain,
  });

  const sdk = useHostStore.getState().sdk;
  if (!sdk) throw new Error("SDK not found, authenticateWithSdk called before sdk is initialised");
  const t = await sdk.auth.authenticate({ walletClient: wallet, jwt });
}
